module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-18.f3e10da1.png";